export class E2EUploadApi {
    client;
    constructor(client) {
        this.client = client;
    }
    async requestE2EUpload(params, requestOptions) {
        return this.client.post('/api/uploads/e2e/request', params, requestOptions);
    }
    async completeE2EUpload(e2eMediaId, requestOptions, options) {
        return this.client.post(`/api/uploads/e2e/${encodeURIComponent(e2eMediaId)}/complete`, options?.skipModeration
            ? {
                skipModeration: true,
                ...(options.moderationSkipReason
                    ? { moderationSkipReason: options.moderationSkipReason }
                    : {}),
            }
            : {}, requestOptions);
    }
    async abandonE2EUpload(e2eMediaId, requestOptions) {
        return this.client.delete(`/api/uploads/e2e/${encodeURIComponent(e2eMediaId)}`, requestOptions);
    }
    async getE2EMediaStatus(e2eMediaId, requestOptions) {
        return this.client.get(`/api/uploads/e2e/${encodeURIComponent(e2eMediaId)}/status`, requestOptions);
    }
    async getE2EMediaDownload(e2eMediaId, requestOptions) {
        return this.client.get(`/api/uploads/e2e/${encodeURIComponent(e2eMediaId)}/download`, requestOptions);
    }
    async requestScanUpload(params, requestOptions) {
        return this.client.post('/api/uploads/scan/request', params, requestOptions);
    }
    async completeScanUpload(scanMediaId, requestOptions) {
        return this.client.post(`/api/uploads/scan/${encodeURIComponent(scanMediaId)}/complete`, {}, requestOptions);
    }
    async sealConvScanSession(params, requestOptions) {
        return this.client.post('/api/uploads/scan/seal', params, requestOptions);
    }
}
//# sourceMappingURL=e2e-upload-api.js.map